import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';


function GmpAuditsComplianceAndTrainingServices() {
  return (
    <div className="font-sans">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'GMP Audit & Compliance', 'GMP Audit, Compliance & Training Service']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          GMP Audit & Compliance
        </h2>

        {/* Section: GMP Audits, Compliance & Training Services */}
        <div className="flex items-center gap-2 mb-4 mt-2">
          <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            GMP Audits, Compliance & Training Services
          </h3>
        </div>

        <p className="text-sm text-[#05326D] mb-2 font-bold">
          Global Quality Assurance for Pharmaceutical, Biotech & Food Industries
        </p>

        <p className="text-sm text-[#05326D] mb-8">
          At FDAC Consultancy, we deliver comprehensive GMP audit, compliance, and training solutions tailored to meet international regulatory standards and evolving industry expectations. Our services are designed to support every participant in the pharmaceutical supply chain—from manufacturers and distributors to MA holders and CROs—ensuring robust quality systems and inspection readiness worldwide.
        </p>

        <hr className="border-t border-gray-300 mb-8" />

        {/* Section: GMP Oversight */}
        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            GMP Audits & Compliance Oversight
          </span>
        </div>

        <p className="text-sm text-[#05326D] font-bold mb-2">
          Independent, Expert-Led Audits Across the Value Chain
        </p>

        <p className="text-sm text-[#05326D] mb-6">
          FDAC’s qualified auditors conduct high-quality, unbiased audits based on current legal requirements and global standards (ICH Q8, Q9, Q10). Our scope includes:
        </p>


        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Audit Coverage
          </span>
        </div>

        <p className="ml-2 mt-2 text-[#05326D]">Formulations, APIs, Intermediates, Key Raw Materials, Excipients, Packaging Materials</p>
        <p className="ml-2 mt-2 text-[#05326D]">Third-Party Manufacturers: Site transfer and technology transfer audits</p>
        <p className="ml-2 mt-2 text-[#05326D]">Vendor & Supplier Qualification Audits</p>
        <p className="ml-2 mt-2 text-[#05326D]">Bioequivalence Study Monitoring & CRO Audits</p>
        <p className="ml-2 mt-2 text-[#05326D]">Data Integrity Audits & Supporting Document Reviews</p>
        <p className="ml-2 mt-2 text-[#05326D]">Inspection Readiness & Pre-Approval GMP Audits</p>
        <p className="ml-2 mt-2 text-[#05326D]">GAP Assessments & Mock Audits</p>
        <p className="ml-2 mt-2 text-[#05326D]">GDP, GLP & QM System Audits</p>


        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Strategic Compliance Support
          </span>
        </div>


        <p className="ml-2 mt-2 text-[#05326D]">SOP Development & QMS Implementation</p>
        <p className="ml-2 mt-2 text-[#05326D]">Cleaning Validation (ADE/PDE-based)</p>
        <p className="ml-2 mt-2 text-[#05326D]">CAPA Monitoring & External Audit Response</p>
        <p className="ml-2 mt-2 text-[#05326D]">Delegated QP Services for MAH/ANDA Batch Review</p>
        <p className="ml-2 mt-2 text-[#05326D]">GMP Facility Design & Construction Advisory</p>
        <p className="ml-2 mt-2 text-[#05326D]">Continuous Improvement Consulting for Manufacturing Processes</p>



        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            GMP Training Programs
          </span>
        </div>

        <p className="text-sm text-[#05326D] font-bold mb-2">
          Onsite, Online & Custom Modules for All Levels of Staff
        </p>

        <p className="text-sm text-[#05326D] mb-6">
          FDAC offers tailored GMP, GLP, GCP, and QMS training programs for pharmaceutical, biotech, and food industries. Our sessions are designed to foster real-world understanding, support change management, and ensure consistent compliance across teams.
        </p>

        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Training Formats
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Onsite & Classroom Training</p>
        <p className="ml-2 mt-2 text-[#05326D]">Online & City-Based Sessions</p>
        <p className="ml-2 mt-2 text-[#05326D]">Shop Floor Demonstrations & Practical Training</p>
        <p className="ml-2 mt-2 text-[#05326D]">Evaluation & Certification for Freshers & Professionals</p>


        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Training Topics
          </span>
        </div>

        <p className="ml-2 mt-2 text-[#05326D]">cGMP Basics & Advanced Modules</p>
        <p className="ml-2 mt-2 text-[#05326D]">Good Documentation Practices (GDP)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Data Integrity & Audit Preparedness</p>
        <p className="ml-2 mt-2 text-[#05326D]">Validation & Qualification Protocols</p>
        <p className="ml-2 mt-2 text-[#05326D]">Regulatory Compliance for FDA, EMA, CDSCO</p>
        <p className="ml-2 mt-2 text-[#05326D]">QMS Implementation & Risk Management</p>


        <div className="flex items-center gap-2 mb-4 mt-4">
          <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
          <span className="text-md font-bold text-[#05326D]">
            Why FDAC?
          </span>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Global reach with local expertise</p>
        <p className="ml-2 mt-2 text-[#05326D]">Accredited third-party audit capabilities</p>
        <p className="ml-2 mt-2 text-[#05326D]">Custom-tailored solutions for product-specific and system-wide compliance</p>
        <p className="ml-2 mt-2 text-[#05326D]">Reduction in audit costs and in-house resource burden</p>
        <p className="ml-2 mt-2 text-[#05326D]">Trusted by MA holders, CROs, and manufacturers worldwide</p>
        <p className="ml-2 mt-2 text-[#05326D]">FDAC is your strategic partner for building resilient quality systems, achieving regulatory excellence, and empowering teams through knowledge.</p>

      </div>
    </div>
  );
}

export default GmpAuditsComplianceAndTrainingServices;
